export default "__VITE_ASSET__1cw96GRs__"